<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

            <h2>Usuários</h2>
            <p>Esta tela é destinada ao gerenciamento dos usuários/alunos deste simulador.</p>

            <div class="row mt-4">
                <div class="col-2">
                    <div class="form-group">
                        <select placeholder="Filtrar por" v-model="filtro" class="form-control">
                            <option value="" selected disabled>Filtrar por...</option>
                            <option value="email">E-mail</option>
                            <option value="nome">Nome</option>
                            <option value="turmas">Turma</option>
                        </select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <input type="text" id="campo_texto" class="form-control" v-model="campo_pesquisa" required placeholder="Pesquisar" @keyup.enter="pesquisar">
                    </div>
                </div>
                <div class="col-2">
                    <div style="text-align: right; width: 100%;" class="mb-5 mt-2">
                        <button @click="pesquisar" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                            <span class="material-icons" style="vertical-align: middle; color: #007BFF;">search</span> 
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Pesquisar</label>
                        </button>
                    </div>
                </div>
                <div class="col-2">
                    <div style="text-align: right; width: 100%;" class="mb-5 mt-2">
                        <button @click="CadastrarAluno()" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                            <span class="material-icons" style="vertical-align: middle; color: #007BFF;">how_to_reg</span> 
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Novo usuário</label>
                        </button>
                    </div>
                </div>
            </div>

            <div class="callout col-xl-12 col-lg-12 col-md-12 mb-4">
                    <div class="card" style="border-left-color: green;">
                        <div class="card-header" data-toggle="collapse" href="#collapse2" style="color: green;">
                            <strong>Usuários cadastrados no Simulador</strong>
                        </div>
                        <div id="collapse2" class="collapse show">
                            <div class="card-body">
                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Nome</th>
                                                <th scope="col" style="background-color: lightgrey;">E-mail</th>
                                                <th scope="col" style="background-color: lightgrey;">Turma(s)</th>
                                                <th scope="col" style="background-color: lightgrey;">Professor</th>
                                                <th scope="col" style="background-color: lightgrey;">Detalhes</th>
                                                <th scope="col" style="background-color: lightgrey;">Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="user in alunos_cadastrados">
                                                <td style="text-align: right;">{{ user.id }}</td>
                                                <td style="text-align: left;">{{ user.name }}</td>
                                                <td style="text-align: left;">{{ user.email }}</td>
                                                <td style="text-align: left;">
                                                    <span v-for="turma in user.turmas" 
                                                        :key="turma.id"
                                                        class="badge bg-secondary me-1">
                                                        {{ turma.descricao }}
                                                    </span>
                                                </td>
                                                <td style="text-align: center;">{{ (user.is_admin ? 'Sim' : 'Não')  }}</td>
                                                <td style="text-align: center;">
                                                    <button @click="detalhes(user.id)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">person</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Detalhes</label>
                                                    </button>
                                                </td>
                                                <td style="text-align: center;">
                                                    <button @click="excluir(user.id)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ users.length }} aluno(s)/usuário(s) encontrado(s).</p>
                            </div>
                        </div>
                    </div>
                </div>

    </div>
  </template>
  
<script>
  import axios from 'axios';
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            campo_pesquisa: '',
            filtro: '',
            alunos_cadastrados: {},
        };
        
    },
    props: {
        users: { //Esses usuários é a lista para o grid.
            type: Object,
            required: true,
        },
        user: Object /* Esse usuário é o usuário logado no sistema */

    },
    mounted() {
        this.alunos_cadastrados = this.users;
    },
    methods: {
        pesquisar(){
            axios.get(this.BASE_URL + 'filtrar_alunos', {
                params: {
                    filtro: this.filtro,
                    valor: this.campo_pesquisa
                }
            })
            .then(response => {
                this.alunos_cadastrados = response.data;
            })
            .catch(error => {
                console.error('Erro na busca:', error);
                alert('Erro na busca:', error);
            });
        },
        excluir(userId){
            if (confirm("Tem certeza que deseja excluir este aluno?")) {
                axios.delete(this.BASE_URL + 'aluno_remover/' + userId)
                    .then(response => {
                        alert(response.data.message);
                        window.location.href = this.BASE_URL + 'consulta_aluno/';
                    })
                .catch(error => {
                    alert('Erro ao deletar o usuário:', error);
                    console.error('Erro ao deletar o usuário:', error);
                });
            }
        },
        detalhes(userId){
            window.location.href = this.BASE_URL + 'cadastro_aluno/' + userId;
        },
        CadastrarAluno(){
            window.location.href = this.BASE_URL + 'cadastro_aluno/';
        },

    },
    
};
</script>

<style scoped>

</style>
  
